// if (document.body.classList.contains('p-contact')) {
//   // URLのパラメータを取得する関数
//   function getQueryParam(param) {
//     var urlParams = new URLSearchParams(window.location.search);
//     return urlParams.get(param);
//   }

//   // placeパラメータを取得
//   var placeParam = getQueryParam('place');

//   // placeパラメータが存在する場合、data-place属性と一致するオプションを選択
//   if (placeParam) {
//     $('select[name="ご希望会場"] option').each(function () {
//       if ($(this).data('place') === placeParam) {
//         $(this).prop('selected', true);
//       }
//     });
//   }
// }

if (document.body.classList.contains('p-contact')) {
  // URLのパラメータを取得する関数
  function getQueryParam(param) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  // placeパラメータを取得
  var placeParam = getQueryParam('place');

  // placeパラメータが存在する場合
  if (placeParam) {
    // セレクトボックスのオプションを選択
    $('select[name="ご希望会場"] option').each(function () {
      if ($(this).data('place') === placeParam) {
        $(this).prop('selected', true);
      }
    });

    // 選択されたセレクトボックスのvalueをhidden項目にセットする
    var selectedValue = $('select[name="ご希望会場"]').val();
    $('input[name="ご希望会場住所"]').val(selectedValue);
    $('input[name="ご希望会場メール"]').val(selectedValue);
    $('input[name="ご希望会場営業時間"]').val(selectedValue);
  }

  // セレクトボックスの選択変更時にhidden項目も更新する
  $('select[name="ご希望会場"]').on('change', function () {
    var selectedValue = $(this).val();
    $('input[name="ご希望会場住所"]').val(selectedValue);
    $('input[name="ご希望会場メール"]').val(selectedValue);
    $('input[name="ご希望会場営業時間"]').val(selectedValue);
  });
}
